import { render, staticRenderFns } from "./ketepatan_pekerjaan.vue?vue&type=template&id=365e65cf"
import script from "./ketepatan_pekerjaan.vue?vue&type=script&lang=js"
export * from "./ketepatan_pekerjaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports